export default ({ id }, topics) => topics.find((topic) => topic.id === id).topics;
